<template>
  <div>
    <form novalidate class="md-layout" @submit.prevent="validarCampos">
      <md-card style="margin: 0 auto;" class="md-layout-item md-size-45">
        <md-card-header>
          <div class="md-title">Adicionar</div>
        </md-card-header>

        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field :class="getValidationClass('sistema')">
                <label for="sistema-origem">Sistema origem</label>
                <md-input name="sistema-origem" id="sistema-origem" v-model="model.sistemaDe" :disabled="sending" />
                <span class="md-error" v-if="!$v.model.sistemaDe.required">Campo obrigatório</span>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field :class="getValidationClass('roleDe')">
                <label for="role-de">De</label>
                <md-input name="role-de" id="role-de" v-model="model.roleDe" :disabled="sending" />
                <span class="md-error" v-if="!$v.model.roleDe.required">Campo obrigatório</span>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field :class="getValidationClass('sistema')">
                <label for="sistema-origem">Sistema destino</label>
                <md-input name="sistema-destino" id="sistema-destino" v-model="model.sistemaPara" :disabled="sending" />
                <span class="md-error" v-if="!$v.model.sistemaPara.required">Campo obrigatório</span>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field :class="getValidationClass('rolePara')">
                <label for="role-para">Para</label>
                <md-input name="role-para" id="role-para" v-model="model.rolePara" :disabled="sending" />
                <span class="md-error" v-if="!$v.model.rolePara.required">Campo obrigatório</span>
              </md-field>
            </div>
          </div>
          <md-field :class="getValidationClass('descricao')">
            <label for="descricao">Descrição</label>
            <md-textarea v-model="model.descricao" :disabled="sending"></md-textarea>
            <md-icon>description</md-icon>
            <span class="md-error" v-if="!$v.model.descricao.maxLenght">A descrição pode conter até 300 caracteres.</span>
            <span class="md-error" v-else-if="!$v.model.descricao.required">Campo obrigatório</span>
          </md-field>
        </md-card-content>

        <md-progress-bar md-mode="indeterminate" v-if="sending" />

        <md-card-actions>
          <md-button type="button" class="md-raised md-dange" :disabled="sending" @click="$emit('closed'); limparFormulario();">Cancelar</md-button>
          <md-button type="submit" class="md-raised md-primary">Cadastrar</md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>

<script>
  import DeParaService from '@/services/DeParaService.js'
  import { validationMixin } from 'vuelidate'
  import {
    required,
    maxLength
  } from 'vuelidate/lib/validators'

  export default {
    name: 'FormCadastrarPerfil',
    mixins: [validationMixin],
    props: ['model'],
    data: () => ({
      form: {
        id: null,
        sistemaDe: null,
        roleDe: null,
        sistemaPara: null,
        rolePara: null,
        descricao: null
      },
      userSaved: false,
      sending: false,
      lastUser: null
    }),
    validations: {
      model: {
        sistemaDe: {
          required
        },
        roleDe: {
          required
        },
        sistemaPara: {
          required
        },
        rolePara: {
          required
        },
        descricao: {
          required,
          maxLenght: maxLength(300)
        },
      }
    },
    created() {
      if (this.$featureToggle.INTEGRA_DEPARA_INSERT) {
        this.deParaService = new DeParaService(this);
      }
      else {
        this.$modal.alert(this.$msgFeatureToggle);
      }
    },
    methods: {
      getValidationClass(fieldName) {
        const field = this.$v.model[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      limparFormulario() {
        this.$v.$reset()
        this.model.id = null
        this.model.sistemaDe = null
        this.model.roleDe = null
        this.model.sistemaPara = null
        this.model.rolePara = null
        this.model.descricao = null
      },

      getModel(model) {
        let m = {
          id: model.id,
          sistemaDe: model.sistemaDe,
          roleDe: model.roleDe,
          sistemaPara: model.sistemaPara,
          rolePara: model.rolePara,
          descricao: model.descricao
        };

        return m;
      },

      salvarPerfil() {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.sending = true

          var funcResult = null;
          //Avalia se existe o id da role depara, caso não exista cadastra um novo, existindo altera o existente
          if (this.model.id != null) {
            //Alterar os dados do depara da role
            funcResult = this.deParaService.updateDePara(this.getModel(this.model));
          }
          else {
            //Inserir um novo depara de role
            funcResult = this.deParaService.insertDePara(this.getModel(this.model));
          }

          //Processa resultado
          funcResult.then(
            data => {
              if (data.ok) {
                this.$emit('closed');

                this.$modal.info(data.mensagem);

                this.lastUser = `${this.form.firstName} ${this.form.lastName}`
                this.userSaved = true
                this.limparFormulario()
              }
              else {
                this.$modal.info(data.Mensagem);
              }
            },
            error => {
              if (error.status != 500)
                this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message || "Não foi possível realizar a inclusão."), error.body?.Detalhe);
              else
                this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message || "Não foi possível realizar a inclusão."), error.body?.Detalhe);
            }).finally(() => {
              this.showLoading = false;
              this.sending = false
            });
        }
      },
      validarCampos() {
        this.$v.$touch()

        if (!this.$v.$invalid) {

          this.salvarPerfil()
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .grid {
    width: 30em;
    overflow-x: auto;
    white-space: pre-wrap;
  }

  .theme-default {
    background-color: #9b9b9b;
    color: white;
  }

  .theme-primary {
    background-color: #448aff;
    color: white;
  }

  .theme-success {
    background-color: #009688;
    color: white;
  }

  .theme-danger {
    background-color: #ff5252;
    color: white;
  }

  .theme-warning {
    background-color: #f9aa33;
    color: white;
  }

  .align-right {
    float: right;
    padding: 20px;
  }

  .padding-20 {
    padding: 0 0 10px 20px;
  }

  .padding-pesquisar {
    padding: 0 0 0 30px;
  }


  .md-table-cell-container {
    padding: 0px;
  }

  .zindex {
    z-index: 1000;
  }

  .md-content {
    margin: 5px;
  }

  .buttonLimpar {
    background-color: transparent;
    border: 0;
  }

  .filtro {
    height: 40px !important;
    font-size: 20px !important;
  }

  .color6361FB {
    color: #6361FB !important;
  }

  .option {
    background-color: #fff !important;
  }

    .option:hover {
      background-color: #6361FB !important;
    }

  .webkit-text-fill-color6361FB {
    -webkit-text-fill-color: #6361FB !important;
  }

  .border6361FB {
    border-bottom-color: #6361FB !important;
  }

  .semMargin {
    padding: 0 !important;
    margin: 0 !important;
  }

  .button {
    background-color: transparent;
    border: 0px;
  }

  .divLeft200 {
    width: 200px;
    float: left;
    position: relative;
    display: inline;
    padding: 5px 0 0 5px
  }

  .divRight {
    width: 100px;
    float: right;
    position: relative;
    display: inline;
    padding: 5px 0 0 5px
  }
</style>
